/// <amd-module name="Test/ManualTestReports/TestReportsCommon/TelemetryConstants" />
export const Area = "TestManagement";
export const TestProgressReportPage = "VSO.TFS.TCM.TestProgressReportPage";
export const TestProgressReportMainComponent = "VSO.TFS.TCM.TestProgressReportMainComponent";
export const TestProgressReportDetailsWidget = "VSO.TFS.TCM.TestProgressReportDetailsWidget";
export const TestProgressReportOverallStateWidget = "VSO.TFS.TCM.TestProgressReportOverallStateWidget";
export const TestProgressReportPointHistoryWidget = "VSO.TFS.TCM.TestProgressReportPointHistoryWidget";

// Features
export const Feature_ProgressReport = "ProgressReport";
export const Feature_FilterFetchError = "FilterFetchError";
export const DetailsWidget_TreeExpansionError = "DetailsWidgetTreeExpansionError";

// Events
export const Event_PageLoaded = "PageLoaded";
export const Event_DetailsWidgetLoaded = "DetailsWidgetLoaded";
export const Event_OutcomeTrendWidgetLoaded = "OutcomeTrendWidgetLoaded";
export const Event_SummaryWidgetLoaded = "SummaryWidgetLoaded";
export const Event_FilterChange = "FilterChange";
export const Event_DetailsWidgetTreeExpand = "DetailsWidgetTreeExpand";
export const Event_DetailsWidgetOpenSuite = "DetailsWidgetOpenSuite";
export const Event_DetailsWidgetColumnSort = "DetailsWidgetColumnSort";
